module.exports = __webpack_public_path__ + "static/media/VE.3e36f29d.png";